<template>
	<div v-if="formData" v-loading="dataLoading">
		<tab name="9">{{id}} {{formData.activityName}} <b v-if="formData && formData.haveEditAudit"
				class="color-danger">存在还未处理的演出修改审核，请处理后再编辑演出信息</b></tab>
		<el-form :model="formData" ref="formData" label-position="top" :disabled="formData && formData.haveEditAudit"
			size="medium">
			<el-card header="演出结款单" shadow="hover" v-if="formData && formData.receivablesAudiList&& formData.receivablesAudiList.length > 0  ">
				<p class="color-warning"><span class="el-icon-warning"></span> 该演出已经产生结款单, 如果你要修改当前页面的 基础信息, 小程序服务费,
					三方渠道服务费, 额外技术服务费, 需要先飞书联系 李娜娜 确认, 避免结算单金额对不上</p>
				<el-table :data="formData.receivablesAudiList" border style="width: 100%" class="MT20" size="small"
					stripe>
					<el-table-column prop="id" label="结款单ID"></el-table-column>
					<el-table-column prop="settlementSession" label="结款场次" min-width="300" show-overflow-tooltip>
						<template slot-scope="scope">
							<div v-if="scope.row.settlementSession" class="session-list">
								<div v-for="(item, idx) in splitSessions(scope.row.settlementSession)" :key="idx"
									class="session-item">
									{{ item }}
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="settlementStatus" label="结款单状态" min-width="90"></el-table-column>
					<el-table-column label="结算单时间" width="260">
						<template slot-scope="scope">
							<p v-if="scope.row.createTime">申请打款时间：{{scope.row.createTime}}</p>
							<p v-if="scope.row.playTime">实际打款时间：{{scope.row.playTime}}</p>
						</template>
					</el-table-column>
				</el-table>
			</el-card>
			<el-card header="基本设置" shadow="hover" class="MT20">
				<el-form-item prop="balanceType" label="结算方式:" :rules="[{required:true,message:'请选择结算方式'}]">
					<el-select v-model="formData.balanceType" @change="balanceTypeChange">
						<el-option :value="1" label="投资演出 - 预付款 - 不走线上结算"></el-option>
						<el-option :value="2" label="非投资演出 - 后付款 - 需指定线上结算方"></el-option>
					</el-select>
					<el-alert v-if="formData.balanceType == 2" type="warning" :closable="false" style="line-height:1.5">
						<p>结算方 = 演出发起人 = {{formData.startUserName}} 账户名：{{formData.accountName}}</p>
						<p v-if="formData.contractNo">合同编号：{{formData.contractNo}} <span v-if="formData.pastDue"
								class="color-danger">(已过期)</span></p>
						<div v-if="data">
							<p v-if="data.contractServiceFeeType == 0">不收取服务费</p>
							<p v-else-if="data.contractServiceFeeType == 1">按固定金额收取服务（{{data.contractServiceFee}}元）</p>
							<p v-else>按比例收取服务（{{data.contractServiceFee}}%）</p>
						</div>
						<el-link class="link color-theme" v-if="formData.searchUserId"
							:href="`/finance/activity/receivables/manage/list?queryValue=${formData.searchUserId}`"
							target="_blank">点击查看收款信息</el-link>
					</el-alert>
				</el-form-item>
				<el-row v-if="formData.balanceType == 1" :gutter="30">
					<!-- 投资类型：仅结算方式为“投资演出-预付款”时展示，必填手选 -->
					<el-col :xs="24" :sm="8">
						<el-form-item prop="investType" :rules="[{required:true,message:'请选择投资类型'}]">
							<span slot="label">
								投资类型：
							</span>
							<el-select v-model="formData.investType" placeholder="请选择投资类型">
								<el-option :value="1" label="秀动主办"></el-option>
								<el-option :value="2" label="财务投资"></el-option>
							</el-select>
							<small class="color-warning">秀动主办类型秀动自己开发票, 财务投资类型主办方开发票</small>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="8">
							<el-form-item prop="investAmount" label="投资金额：" :rules="[{required:true,message:'请填写投资金额'}]">
							<el-row :gutter="10">
								<el-col :span="22">
									<el-input-number style="width:100%" v-model="formData.investAmount"
										controls-position="right" :min="0.01" :max="99999999.99"
										:precision="2"></el-input-number>
								</el-col>
								<el-col :span="2">
									元
								</el-col>
							</el-row>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="8">
						<el-form-item prop="expectedBoxOffice" label="预期票房："
							:rules="[{required:true,message:'请填写预期票房'}]">
							<el-row :gutter="10">
								<el-col :span="22">
									<el-input-number style="width:100%" v-model="formData.expectedBoxOffice"
										controls-position="right" :min="0.01" :max="99999999.99"
										:precision="2"></el-input-number>
								</el-col>
								<el-col :span="2">
									元
								</el-col>
							</el-row>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item prop="serviceFeeType" label="服务费用收取方式:" :rules="[{required:true,message:'请选择服务费用收取方式'}]">
					<span slot="label">
						服务费用收取方式：
						<el-button type="text" @click="clickHandle()">一键填写合同中规定的【收取方式】以及【费用】</el-button>
					</span>
					<el-select v-model="formData.serviceFeeType" @change="scopeChange">
						<el-option :value="0" label="不收取"></el-option>
						<el-option :value="1" label="固定金额"></el-option>
						<el-option :value="2" label="按比例收取"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="formData.serviceFeeType != 0" prop="serviceFee" label="服务费用:"
					:rules="[{required:true,message:'请输入服务费用'}]">
					<el-row :gutter="10">
						<el-col :span="22">
							<el-input-number style="width:100%" v-model="formData.serviceFee" controls-position="right"
								:min="formData.serviceFeeType == 1 ? 0.01 : 0.00"
								:max="formData.serviceFeeType == 1 ? 99999999.99 : 100.00"
								:precision="2"></el-input-number>
						</el-col>
						<el-col :span="2">
							{{formData.serviceFeeType == 1 ? '元' : '%'}}
						</el-col>
					</el-row>
				</el-form-item>
				<template
					v-if="formData.balanceType == 2 && formData.serviceFeeType == 2 || formData.agentUserId && formData.isCanEditAgentServiceFee == 0">
					<el-form-item prop="agentUserId" label="代理商:">
						<el-select v-model="formData.agentUserId" filterable remote :remote-method="searchAgent"
							:loading="userLoading" clearable
							:disabled="formData.isCanEditAgentServiceFee == 0 ? true : false">
							<el-option v-for="item in agentList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="formData.agentUserId" prop="agentServiceFee"
						:rules="[{required:true,message:'请输入代理费占票提比例'}]">
						<span slot="label">
							代理费占票提比例：
							<small>
								占票提的百分比, 比如占票提服务费的 30%
								<el-button v-if="formData.isCanEditAgentServiceFee == 1" type="text" size="mini"
									@click="setAgentServiceFee()">一键填写合同中规定的代理费比例</el-button>
							</small>
						</span>
						<el-row :gutter="10">
							<el-col :span="22">
								<el-input-number style="width:100%" v-model="formData.agentServiceFee"
									controls-position="right" :step="0.01" :min="0.00" :max="100.00" :precision="2"
									:disabled="formData.isCanEditAgentServiceFee == 0 ? true : false"></el-input-number>
							</el-col>
							<el-col :span="2">
								%
							</el-col>
						</el-row>
					</el-form-item>
				</template>
				<el-row :gutter="20">
					<el-col :xs="24" :sm="12">
						<el-form-item prop="isAdvanceBalance" label="提前结款状态:">
							<el-radio-group v-model="formData.isAdvanceBalance">
								<el-radio :label="0">未提前结款</el-radio>
								<el-radio :label="1">已提前结款</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12">
						<el-form-item prop="isNormalBalance" label="是否正常结款:">
							<el-radio-group v-model="formData.isNormalBalance">
								<el-radio :label="1">正常结款</el-radio>
								<el-radio :label="0">暂停结款</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :xs="24" :sm="14">
						<el-form-item prop="selectedItems" label="特殊结款标识:" >
							 <el-checkbox-group v-model="formData.selectedItems">
							    <el-checkbox
							      v-for="(text, key) in specialSettlement"
							      :key="key"
							      :label="key"
							    >
							      {{ text }}
							    </el-checkbox>
							  </el-checkbox-group>
						</el-form-item>
					</el-col>
				</el-row>
			</el-card>
			<el-card header="小程序服务费" class="MT20" shadow="hover">
				<el-row :gutter="20">
					<el-col :span="8">
						<el-form-item prop="douyinServiceFee" label="抖音生活服务费比例:"
							:rules="[{required:true,message:'请填写抖音生活服务费比例'}]">
							<el-input-number :disabled="formData.isCanEditTechnicalServiceFee == 0 ? true : false"
								style="width:95%" v-model="formData.douyinServiceFee" controls-position="right"
								:precision="2"></el-input-number> %
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item prop="redBookletServiceFee" label="小红书服务费比例:"
							:rules="[{required:true,message:'请填写小红书服务费比例'}]">
							<el-input-number style="width:95%" v-model="formData.redBookletServiceFee"
								controls-position="right" :precision="2"></el-input-number> %
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item prop="aliAppletServiceFee" label="支付宝小程序服务费比例:"
							:rules="[{required:true,message:'请填写支付宝小程序服务费比例'}]">
							<el-input-number style="width:95%" v-model="formData.aliAppletServiceFee"
								controls-position="right" :precision="2"></el-input-number> %
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="8">
						<el-form-item prop="meiTuanServiceFee" label="美团小程序服务费比例:"
							:rules="[{required:true,message:'请填写美团小程序服务费比例'}]">
							<el-input-number style="width:95%" v-model="formData.meiTuanServiceFee"
								controls-position="right" :precision="2"></el-input-number> %
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item prop="douyinCpsUnderwriter" label="抖音小程序CPS佣金:"
							:rules="[{required:true,message:'请选择抖音小程序CPS佣金'}]">
							<el-select v-model="formData.douyinCpsUnderwriter" style="width:95%">
								<el-option :value="0" label="主办承担"></el-option>
								<el-option :value="1" label="秀动承担"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item prop="redBookletCpsUnderwriter" label="小红书小程序CPS佣金:"
							:rules="[{required:true,message:'请选择小红书小程序CPS佣金'}]">
							<el-select v-model="formData.redBookletCpsUnderwriter" style="width:95%">
								<el-option :value="0" label="主办承担"></el-option>
								<el-option :value="1" label="秀动承担"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="8" v-if="formData.douyinCpsUnderwriter == 1">
						<el-form-item prop="douyinCpsUnderwriterDep" label="抖音 CPS 佣金秀动承担部门"
							:rules="[{ required: formData.douyinCpsUnderwriter == 1 ? true : false, message: '请选择抖音 CPS 佣金秀动承担部门', trigger: 'change' }]">
							<el-select v-model="formData.douyinCpsUnderwriterDep" placeholder="请选择抖音 CPS 佣金秀动承担部门"
								class="fl fl-big-select" clearable size="small" filterable style="width:95%">
								<el-option v-for="(item, index) in departmentList" :label="item.value" :key="index"
									:value="item.key"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8" v-if="formData.redBookletCpsUnderwriter == 1">
						<el-form-item prop="redBookletCpsUnderwriterDep" label="小红书 CPS 佣金秀动承担部门"
							:rules="[{ required: formData.redBookletCpsUnderwriter == 1 ? true : false, message: '请选择小红书 CPS 佣金秀动承担部门', trigger: 'change' }]">
							<el-select v-model="formData.redBookletCpsUnderwriterDep" class="fl fl-big-select"
								filterable remote placeholder="请选择小红书 CPS 佣金秀动承担部门" @change="getDepartment"
								size="medium"  style="width:95%">
								<el-option v-for="item in departmentList" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-card>
			<el-card class="MT20" shadow="hover">
				<div slot="header" class="clearfix">
					<span>第三方渠道服务费</span>
					<span class="ML20 color-theme">（活动类型: {{ formData.showTypeTagName}}）</span>
				</div>
				<table class="info-table" style="width:100%">
					<tr>
						<th>渠道名称</th>
						<th>服务费比例</th>
						<th>说明</th>
					</tr>
					<tr v-for="(item, index) in formData.thirdServiceFee" :key="index">
						<td>{{item.name}}</td>
						<td>
							<el-input-number style="width:80%" v-model="item.value" controls-position="right"
								:precision="2"></el-input-number> %
						</td>
						<td>{{item.tips}}</td>
					</tr>
				</table>
			</el-card>
			<!-- <el-col :xs="24" :sm="12">
			<el-card header="退票规则（设置对象：整场演出）">
				<refund-rule :formData.sync="formData" :sessionRefundRules.sync="sessionRefundRules"></refund-rule>
			</el-card>
		</el-col> -->
			<el-card class="MT20" header="额外技术服务费" shadow="hover">
				<div slot="header">
					额外技术服务费：（总金额汇总：{{ formData.technicalServiceFeeTotalStr || 0 }}）
					<el-button v-if="formData.isCanEditTechnicalServiceFee != 0" type="primary" plain size="mini"
						@click="addTechnicalServiceFee()">新增</el-button>
				</div>
				<div class="tsf-list">
					<div v-for="(item, index) in formData.technicalServiceFeeList" :key="index" class="tsf-item">
						<el-form-item :label="index == 0 ? '费用项目：' : ''"
							:prop="`technicalServiceFeeList[${index}].item`"
							:rules="[{ required: item.amount > 0 ? true : false, message: '请输入费用项目', trigger: 'change' }]">
							<el-input v-model="item.item" placeholder="请输入费用项目" maxlength="30"
								:disabled="formData.isCanEditTechnicalServiceFee == 0 || item.type === 1 ? true : false"
								@input="changeTechnicalServiceFee"></el-input>
						</el-form-item>
						<el-form-item :label="index == 0 ? '金额：' : ''"
							:prop="`technicalServiceFeeList[${index}].amount`"
							:rules="[{ required: item.item ? true : false, message: '请输入费用项目', trigger: 'change' }]">
							<el-input-number v-model="item.amount" :min="0" :max="999999999" :precision="2"
								controls-position="right" style="width: 100%;"
								:disabled="formData.isCanEditTechnicalServiceFee == 0 || item.type === 1 ? true : false"
								@change="changeTechnicalServiceFee"></el-input-number>
						</el-form-item>
						<el-button :style="`margin-top: ${index == 0 ? 47 : 0}px`"
							:disabled="formData.isCanEditTechnicalServiceFee == 0 || item.type === 1 ? true : false"
							type="danger" plain @click="delTechnicalServiceFee(index)" size="medium">删除</el-button>
					</div>
				</div>
			</el-card>
			<el-card header="退票规则" class="MT20" shadow="hover">
				<refund-rule :formData.sync="formData" :activeRefundType="activeRefundType"></refund-rule>
			</el-card>
		</el-form>
		<div class="MT20">
			<el-button @click="goBack">返回</el-button>
			<el-button v-if="$utils.have('/activity/saveFinanceInfo')" type="primary" @click="onSubmit"
				:loading="btnLoading" :disabled="formData && formData.haveEditAudit">保存</el-button>
		</div>

		<el-dialog title="修改财务信息提醒" :visible.sync="dialogVisible2" width="70%"
			v-if="formData && formData.receivablesAudiList">
			<div class="dialog-content">
				<p class="color-warning"><span class="el-icon-warning"></span> 你修改了演出财务信息, 这会影响演出结算, 需要先飞书联系 李娜娜 确认,
					避免结算金额不一致</p>
				<el-table :data="formData.receivablesAudiList" border style="width: 100%" class="MT20" size="small"
					stripe>
					<el-table-column prop="id" label="结款单ID"></el-table-column>
					<el-table-column prop="settlementSession" label="结款场次" min-width="300" show-overflow-tooltip>
						<template slot-scope="scope">
							<div v-if="scope.row.settlementSession" class="session-list">
								<div v-for="(item, idx) in splitSessions(scope.row.settlementSession)" :key="idx"
									class="session-item">
									{{ item }}
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="settlementStatus" label="结款单状态" min-width="90"></el-table-column>
					<el-table-column label="结算单时间" width="260">
						<template slot-scope="scope">
							<p v-if="scope.row.createTime">申请打款时间：{{scope.row.createTime}}</p>
							<p v-if="scope.row.playTime">实际打款时间：{{scope.row.playTime}}</p>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible2=false">取 消</el-button>
				<el-button type="primary" @click="confirmModify" :loading="dialogVisible2Btn">已联系，确认修改</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import Tab from '../components/tab';
	import RefundRule from './components/refund-rule.vue';
	import {
		fetchAgent
	} from '@/assets/js/commonApi';
	const _defaultFormData = {
		activityId: "",
		balanceType: "",
		investType: "", // 投资类型 1:秀动主办 2:财务投资（仅投资演出-预付款）
		expectedBoxOffice: undefined,
		investAmount: undefined,
		isAdvanceBalance: 0,
		serviceFee: "",
		serviceFeeType: 0,
		startUserId: "",
		damaiServiceFee: 0,
		douyinServiceFee: 3.90,
		redBookletServiceFee: 3.0,
		neteaseCloudServiceFee: 0,
		qqServiceFee: 0,
		maoyanServiceFee: 0, //（猫眼服务费）, 
		piaoxingqiuServiceFee: 0, //（票星球服务费）
		aliAppletServiceFee: 0, //（支付宝小程序服务费）,
		meiTuanServiceFee:0,//美团小程序服务费
		douyinCpsUnderwriter: 0,
		redBookletCpsUnderwriter: 0,
		refundFeeDivide: 0,
		activeRefund: 0,
		refundServiceTemplateId: 67,
		refundServiceTemplateIdShow: 1,
		smgServiceFee: 3.0,
		douyinCpsUnderwriterDep: [],
		redBookletCpsUnderwriterDep: [],
		thirdServiceFee: [],
		refundRule: {
			"firstLevel": {
				"node": 1,
				"timeNum": 3,
				"unit": "d",
				"open": 1
			},
			"middleLevel": [{
					"timeNode": 1,
					"timeNum": 33,
					"feeRatio": 30
				},
				{
					"timeNode": 2,
					"timeNum": 33,
					"feeRatio": 70
				},
				{
					"timeNode": 3,
					"timeNum": 34,
					"feeRatio": 70
				}
			],
			"lastLevel": {
				"node": 1,
				"timeNum": 1,
				"unit": "d"
			},
			"orderLevel": {
				"node": 1,
				"timeNum": 3,
				"unit": "h",
				"open": 1
			}
		},
		agentUserId: "",
		agentServiceFee: undefined,
		technicalServiceFeeList: [],
		isNormalBalance: 1,
		
		selectedItems: []

	}
	export default {
		props: {
			id: {
				type: [Number, String],
				default: () => null
			}
		},
		components: {
			Tab,
			RefundRule
		},
		data() {
			return {
				formData: {
					..._defaultFormData,
					technicalServiceFeeList: []
				},
				dataLoading: false,
				btnLoading: false,
				redirect: this.$route.query.redirect,
				data: null,
				activeRefundType: '',
				agentList: [],
				userLoading: false,
				departmentList: [],
				dialogVisible2: false,
				dialogVisible2Btn: false,
				checkLoading: false,
				specialSettlement: {
				  1: '涉及结款分账(结给多个主办)',
				  2: '有过二次退款',
				  3: '涉及线下分销结款',
				  4: '第三方服务费秀动承担',
				  5: '有额外费用需要票款抵扣'
				},
			}
		},
		created() {
			if (this.id) {
				this.getDataDetail();
			}
			this.getDepartment()
		},
		methods: {
			//返回
			goBack() {
				if (this.redirect) {
					this.$router.push({
						path: this.redirect,
					});
				} else {
					this.$router.go(-1);
				}
			},
			splitSessions(sessionStr) {
				if (!sessionStr) return [];
				return sessionStr.split(/[,，]+/).map(s => s.trim()).filter(s => s);
			},
			//获取详情
			getDataDetail() {
				this.dataLoading = true;
				this.$request({
						url: "/activity/financeInfo",
						params: {
							activityId: parseInt(this.id)
						},
						method: "post",
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1) {
							this.formData = {
								..._defaultFormData,
								...result,
								activityId: result.activityId || this.id,
								douyinCpsUnderwriterDep: result.douyinCpsUnderwriterDep ? result
									.douyinCpsUnderwriterDep.toString() : [],
								redBookletCpsUnderwriterDep: result.redBookletCpsUnderwriterDep ? result
									.redBookletCpsUnderwriterDep.toString() : []
							}
							this.data = {
								...result,
							}
							if (result.agentUser) {
								this.formData.agentUserId = result.agentUser.id;
								this.agentList = [{
									...result.agentUser,
									serviceFee: result.agentContractServiceFee,
									serviceFeeType: result.agentContractServiceFeeType
								}]
							}
							
							if (result.specialSettlement) {
							    this.formData.selectedItems = Object.keys(result.specialSettlement);
							}

							if (result.sessionRefundRules) {
								const hasOrderLevel = result.sessionRefundRules.some(item => item.orderLevel);

								if (!hasOrderLevel) {
									// 创建新数组，每个项都包含 orderLevel
									this.formData.sessionRefundRules = result.sessionRefundRules.map(item => ({
										...item,
										orderLevel: {
											node: 1,
											timeNum: 24,
											unit: "h",
											open: 0
										}
									}));
								} else {
									this.formData.sessionRefundRules = result.sessionRefundRules;
								}
							}

						} else {
							this.$message.error(msg || "获取财务信息失败,请重试");
						}
					})
					.catch(() => {
						this.$message.error("获取财务信息失败,请重试");
					})
					.finally(() => {
						this.dataLoading = false;
					});
			},

			// 搜索承担部门
			async getDepartment(query) {
				if (query !== "") {
					this.$request({
						url: "/common/underwriterDep",
						method: "post",
					}).then(res => {
						const {
							state,
							result
						} = res.data;
						if (state == 1) {
							this.departmentList = result || []
						}
					})
				}
			},
			//结算方式切换：切为非投资演出时清空投资类型
			balanceTypeChange(val) {
				if (val != 1) {
					this.formData.investType = '';
				}
			},
			//范围切换
			scopeChange(e) {
				if (e == 1) {
					this.formData.serviceFee = 10.00;
				} else {
					this.formData.serviceFee = 0.00;
				}
				this.$refs["formData"].clearValidate('serviceFee');
			},
			clickHandle() {
				this.formData.serviceFeeType = this.data.contractServiceFeeType
				this.formData.serviceFee = this.data.contractServiceFee
			},
			async prepareSubmitData() {
				// 1. 表单基础校验
				let valid = false;
				try {
					valid = await this.$refs["formData"].validate();
				} catch (e) {
					valid = false;
				}
				if (!valid) return null;

				// 2. 退票规则类型处理
				if (this.formData.refundRuleType == 1) {
					this.formData.sessionRefundRules = [];
					this.formData.refundRule = null;
				}
				if (this.formData.refundRuleType == 2) {
					this.formData.sessionRefundRules = [];
				}
				if (this.formData.refundRuleType == 3) {
					this.formData.refundRule = null;
				}

				// 3. 收费退票百分比总和校验
				if (this.formData.refundRuleType == 2) {
					let _totalTime = 0;
					this.formData.refundRule.middleLevel.map(v => {
						_totalTime += v.timeNum;
					});
					if (_totalTime != 100) {
						this.$message.error('收费退票中3个时间段百分比总和必须为100%');
						return null;
					}
				}

				// 4. 技术服务费去重校验
				const _technicalServiceFeeList = this.formData.technicalServiceFeeList.filter(v => v.item);
				let _new__technicalServiceFeeList = [];
				if (_technicalServiceFeeList.length > 0) {
					_new__technicalServiceFeeList = _technicalServiceFeeList.filter((item, index) => {
						return _technicalServiceFeeList.findIndex((v, i) => v.item == item.item) == index;
					});
				}
				if (_technicalServiceFeeList.length != _new__technicalServiceFeeList.length) {
					this.$message.error('技术服务费用项目不可重复');
					return null;
				}

				// 5. 退票模板ID处理
				if (this.formData.refundServiceTemplateIdShow == 1) {
					if (this.formData.refundServiceTemplateId && this.formData.refundServiceTemplateId.length > 0) {
						this.formData.refundServiceTemplateId = this.formData.refundServiceTemplateId.slice(-1)[0];
					}
				} else {
					this.formData.refundServiceTemplateId = '';
				}

				// 6. 场次退票规则 orderLevel 同步
				if (this.formData.sessionRefundRules && this.formData.sessionRefundRules.length > 0) {
					const defaultOrderLevel = this.formData.sessionRefundRules[0].orderLevel;
					this.formData.sessionRefundRules = this.formData.sessionRefundRules.map(session => ({
						...session,
						orderLevel: {
							...defaultOrderLevel
						}
					}));
				}
				const selectedKeys = this.formData.selectedItems; // 例如 [1, 2]
				const payload = {};
				selectedKeys.forEach(key => {
				  payload[key] = {}; // 统一赋值为空对象
				});
				console.log(payload)
				this.formData.specialSettlement = payload
				// 7. 构建最终提交数据
				const submitData = {
					...this.formData,
					agentUserId: this.formData.serviceFeeType != 2 ? "" : this.formData.agentUserId,
					agentServiceFee: this.formData.serviceFeeType != 2 ? 0 : this.formData.agentServiceFee,
					technicalServiceFeeList: _new__technicalServiceFeeList,
					douyinCpsUnderwriterDep: this.formData.douyinCpsUnderwriter == 1 ? this.formData
						.douyinCpsUnderwriterDep : '',
					redBookletCpsUnderwriterDep: this.formData.redBookletCpsUnderwriter == 1 ? this.formData
						.redBookletCpsUnderwriterDep : '',
				};
				
				
				return submitData;
			},

			/**
			 * 执行保存请求
			 */
			doSave(submitData) {
				this.btnLoading = true;
				this.$request({
						url: "/activity/saveFinanceInfo",
						method: "POST",
						data: submitData,
					})
					.then((res) => {
						const {
							state,
							msg
						} = res.data;
						if (state && state == 1) {
							this.$confirm('操作成功', '提示', {
								type: 'success',
								center: true,
								confirmButtonText: '返回列表',
								cancelButtonText: '留在当前页面',
								closeOnClickModal: false
							}).then(() => {
								this.goBack();
							}).catch(() => {
								this.getDataDetail();
							})
						} else {
							this.$message.error(msg || "操作失败");
						}
					})
					.finally(() => {
						this.btnLoading = false;
					});
			},

			/**
			 * 表单提交入口：先调用校验接口，根据 needRemind 决定是否弹窗确认
			 */
			async onSubmit() {
				// 预处理数据并校验
				const submitData = await this.prepareSubmitData();
				if (!submitData) return;

				// 调用校验接口
				this.checkLoading = true;
				this.$request({
						url: "/activity/settlement/edit/check",
						method: "POST",
						data: {
							activityId: this.formData.id || this.id,
							data: submitData,
							type: 2
						},
					})
					.then((res) => {
						const {
							state,
							result
						} = res.data;
						if (state == 1) {
							if (result.needRemind) {
								// 需要提醒，展示弹窗
								this.dialogVisible2 = true;
							} else {
								// 无需提醒，直接保存
								this.doSave(submitData);
							}
						} else {
							this.$message.error(res.data.msg || "校验失败，请重试");
						}
					})
					.catch(() => {
						this.$message.error("校验接口调用失败，请重试");
					})
					.finally(() => {
						this.checkLoading = false;
					});
			},

			/**
			 * 弹窗确认修改：关闭弹窗并执行保存
			 */
			confirmModify() {
				this.dialogVisible2Btn = true;
				// 重新获取最新的表单数据（防止弹窗期间用户修改）
				this.prepareSubmitData().then(submitData => {
					if (submitData) {
						this.doSave(submitData);
					}
					this.dialogVisible2 = false;
					this.dialogVisible2Btn = false;
				}).catch(() => {
					this.dialogVisible2Btn = false;
				});
			},

			// 搜索代理商
			async searchAgent(query) {
				console.log(query)
				if (query !== "") {
					this.userLoading = true;
					const res = await fetchAgent(query)
						.finally(() => {
							this.userLoading = false;
						});

					const {
						state,
						result
					} = res.data;

					if (state == 1 && result) {
						this.agentList = result || [];
					}
				}
			},
			setAgentServiceFee() {
				if (this.formData.agentUserId) {
					const _agent = this.agentList.find(v => v.id == this.formData.agentUserId)
					if (_agent) {
						this.formData.agentServiceFee = _agent.serviceFeeType == 0 ? 0 : _agent.serviceFee || 0
					}
				}
			},
			//新增技术服务费
			addTechnicalServiceFee() {
				this.formData.technicalServiceFeeList.push({
					item: '',
					amount: ''
				})
			},
			// 删除技术服务费
			delTechnicalServiceFee(index) {
				this.formData.technicalServiceFeeList.splice(index, 1)
				this.changeTechnicalServiceFee();
			},
			//计算技术服务费总和
			changeTechnicalServiceFee() {
				var total = 0;
				for (var i = 0; i < this.formData.technicalServiceFeeList.length; i++) {
					if (this.formData.technicalServiceFeeList[i].item) {
						total += this.formData.technicalServiceFeeList[i].amount;
					}
				}
				this.formData.technicalServiceFeeTotalStr = total;
			}
		}
	}
</script>
<style lang="scss" scoped>
	.contractNo {
		padding-left: 20px;
	}

	.link {
		font-size: 12px;
	}

	.el-card {
		height: 100%;
	}

	::v-deep {
		.el-row--flex {
			flex-wrap: wrap;
		}
	}

	.tsf-list {
		.tsf-item {
			display: flex;
			align-items: flex-start;

			.el-form-item {
				margin-right: 10px;
				flex: 1;
			}

		}
	}

	.info-table td {
		border-right: 1px solid #eee;
		padding-left: 20px;
	}

	.info-table th {
		padding: 5px 0 5px 20px;

	}
</style>